// Number / money formatting shared across Risk Monitoring tables and KPI cards.
// Mirrors the legacy nop-live/utils/number-format.js conventions.

// renderDateTime parity: DD/MM/YYYY HH:mm:ss (blank for null/invalid).
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

// Date-only parity: DD/MM/YYYY (blank for null/invalid).
export function formatDateOnly(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatNumber(value: number | null | undefined, decimals = 2): string {
  if (value == null || Number.isNaN(value)) return 'N/A';
  return value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatMoney(value: number | null | undefined, decimals = 2): string {
  if (value == null || Number.isNaN(value)) return 'N/A';
  return value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

// PnL sign class (matches renderNopPnl: positive=text-primary, negative=text-danger).
export function pnlClass(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value) || value === 0) return '';
  return value > 0 ? 'text-primary' : 'text-danger';
}

// Expected-EOD-swap cell: NA when null, signed +/- with success/danger (matches
// rdRenderEodSwap / _formatEodSwapHtml).
export function formatEodSwap(value: number | null | undefined): { text: string; cls: string } {
  if (value == null || Number.isNaN(value)) return { text: 'NA', cls: 'text-muted' };
  if (Math.abs(value) < 0.00005) return { text: '0.00', cls: '' };
  const sign = value > 0 ? '+' : '-';
  const abs = Math.abs(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return { text: `${sign}${abs}`, cls: value > 0 ? 'text-success' : 'text-danger' };
}
